import React, { Component } from "react";
import { Fade } from "react-reveal";
import { leadershipData } from "../../portfolio.js";
import "./MapSection.css";
import { useLanguage } from "../../context/LanguageContext";
import { getTranslation } from "../../translations/translations";

const MapContent = ({ theme }) => {
  const { language } = useLanguage();

  return (
    <div className="map-main">
      <div className="map-header">
        <Fade bottom duration={1000} distance="40px">
          <h2 className="map-heading" style={{ color: theme.text }}>
            {getTranslation(language, "find_us")}
          </h2>
          <p className="map-subtitle" style={{ color: theme.secondaryText }}>
            {leadershipData.address.street}, {leadershipData.address.city}
          </p>
        </Fade>
      </div>

      <Fade bottom duration={1500} distance="40px">
        <div className="map-container">
          <iframe
            title="Church Location"
            className="map-frame"
            src={leadershipData.address.mapEmbed}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </Fade>

      <div className="map-info">
        <Fade bottom duration={1500} distance="40px">
          <a
            href={leadershipData.address.mapLink}
            target="_blank"
            rel="noopener noreferrer"
            className="map-link-button"
            style={{ backgroundColor: theme.highlight, color: theme.body }}
          >
            {getTranslation(language, "open_maps")}
          </a>
        </Fade>
      </div>
    </div>
  );
};

class MapSection extends Component {
  render() {
    return <MapContent theme={this.props.theme} />;
  }
}

export default MapSection;
